import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosConfig';

export const fetchChangeRequests = createAsyncThunk(
  'changeRequests/fetchAll',
  async ({ filter, token }, { rejectWithValue }) => {
    try {
      const url = filter === 'all' 
        ? '/api/admin/change-requests'
        : `/api/admin/change-requests/status/${filter}`;
      
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch requests');
    }
  }
);

export const approveRequest = createAsyncThunk(
  'changeRequests/approve',
  async ({ id, token }, { rejectWithValue }) => {
    try {
      await axios.post(`/api/admin/change-requests/${id}/approve`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to approve');
    }
  }
);

export const rejectRequest = createAsyncThunk(
  'changeRequests/reject',
  async ({ id, reason, token }, { rejectWithValue }) => {
    try {
      await axios.post(`/api/admin/change-requests/${id}/reject`, 
        { reason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to reject');
    }
  }
);

const initialState = {
  list: [],
  filter: 'pending',
  loading: false,
  error: null
};

const changeRequestSlice = createSlice({
  name: 'changeRequests',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChangeRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChangeRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchChangeRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(approveRequest.fulfilled, (state, action) => {
        state.list = state.list.filter(r => r.id !== action.payload);
      })
      .addCase(rejectRequest.fulfilled, (state, action) => {
        state.list = state.list.filter(r => r.id !== action.payload);
      });
  }
});

export const selectChangeRequests = (state) => state.changeRequests.list;
export const selectChangeRequestsLoading = (state) => state.changeRequests.loading;
export const selectChangeRequestsFilter = (state) => state.changeRequests.filter;

export const { setFilter, clearError } = changeRequestSlice.actions;
export default changeRequestSlice.reducer;
